import { logger } from '../logger';

/**
 * Logger for API-related operations
 * Use this for HTTP requests, responses, and API errors
 */
const apiLogger = logger.child('API');

export default apiLogger;
